import { FormType } from '@cod-monorepo/interfaces';
import { StepConfig } from '../../../../shared/types/step-config.type';

export const OrderEntryDomesticStepConfig: StepConfig = {
    type: FormType.ORDER_ENTRY_DOMESTIC
};
